"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var bind_1 = require("../bind");
var constants_1 = require("../constants");
var is_mobile_1 = require("../is-mobile");
var react_textarea_autosize_1 = require("react-textarea-autosize");
var money_1 = require("../money");
// Does this keyboard event print a character to the input?
function isPrinting(e) {
    return e.key.length === 1 && !e.altKey && !e.ctrlKey && !e.metaKey;
}
/**
 * [Controlled component](https://reactjs.org/docs/forms.html#controlled-components)
 * to wrap HTML inputs or textarea based on inputType prop
 *
 * Change events are passed to the updateField prop
 *
 * For labels and input error handling, use with FormGroupWithInput
 */
var ControlledInput = /** @class */ (function (_super) {
    tslib_1.__extends(ControlledInput, _super);
    function ControlledInput() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ControlledInput.prototype.onKeyDown = function (event) {
        if (this.props.numberOnly && isPrinting(event) && !event.key.match(constants_1.NUMBER_OR_FLOAT_KEYS_REGEX)) {
            event.preventDefault();
        }
    };
    ControlledInput.prototype.updateField = function (event) {
        var attributes = {};
        attributes[this.props.fieldName] = event.target.value;
        this.props.updateField(attributes);
    };
    ControlledInput.prototype.onBlur = function (event) {
        if (!this.props.onBlur)
            return;
        var attributes = {};
        attributes[this.props.fieldName] = event.target.value;
        this.props.onBlur(event, attributes);
    };
    Object.defineProperty(ControlledInput.prototype, "inputType", {
        get: function () {
            // if a numeric input, mobile, AND english, we can safely use the 'number' type
            if (this.props.numberOnly && is_mobile_1.default && money_1.hasPeriodDecimalSeparator()) {
                return 'number';
            }
            return this.props.inputType || 'text';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ControlledInput.prototype, "placeholder", {
        get: function () {
            return this.props.placeholder;
        },
        enumerable: true,
        configurable: true
    });
    ControlledInput.prototype.getStep = function () {
        if (this.inputType === 'number') {
            return { step: '0.01' || this.props.step };
        }
    };
    ControlledInput.prototype.shouldRenderInputGroup = function () {
        return (!!this.props.currencyPrefix || !!this.props.currencySuffix);
    };
    ControlledInput.prototype.inputGroupClass = function () {
        if (this.shouldRenderInputGroup())
            return 'input-group__input';
        return this.props.className;
    };
    ControlledInput.prototype.renderInputOrGroup = function () {
        if (this.shouldRenderInputGroup()) {
            return (React.createElement("div", { className: "input-group" },
                !!this.props.currencyPrefix &&
                    React.createElement("div", { className: "input-group__text" }, this.props.currencyPrefix),
                this.renderInput(),
                !!this.props.currencySuffix &&
                    React.createElement("div", { className: "input-group__text" }, this.props.currencySuffix)));
        }
        return this.renderInput();
    };
    ControlledInput.prototype.renderInput = function () {
        return (React.createElement("input", tslib_1.__assign({ autoCapitalize: this.props.autoCapitalize, autoCorrect: this.props.autoCorrect, autoFocus: this.props.autoFocus, checked: this.props.checked, className: this.inputGroupClass(), disabled: this.props.disabled, id: this.props.id || this.props.inputName, maxLength: this.props.maxLength, name: this.props.inputName, onChange: this.updateField, onKeyDown: this.onKeyDown, pattern: this.props.pattern, placeholder: this.props.placeholder, required: this.props.required, spellCheck: this.props.spellCheck, type: this.inputType, value: this.props.inputValue }, this.getStep())));
    };
    ControlledInput.prototype.render = function () {
        if (this.props.inputType === 'textarea') {
            return (React.createElement(react_textarea_autosize_1.default, { autoCapitalize: this.props.autoCapitalize, autoCorrect: this.props.autoCorrect, autoFocus: this.props.autoFocus, className: this.props.className, disabled: this.props.disabled, id: this.props.id || this.props.inputName, maxLength: this.props.maxLength, name: this.props.inputName, onChange: this.updateField, onKeyDown: this.onKeyDown, placeholder: this.props.placeholder, required: this.props.required, rows: this.props.rows, spellCheck: this.props.spellCheck, value: this.props.inputValue, maxRows: 30 }));
        }
        return this.renderInputOrGroup();
    };
    ControlledInput.defaultProps = {
        rows: 5,
    };
    tslib_1.__decorate([
        bind_1.default
    ], ControlledInput.prototype, "onKeyDown", null);
    tslib_1.__decorate([
        bind_1.default
    ], ControlledInput.prototype, "updateField", null);
    tslib_1.__decorate([
        bind_1.default
    ], ControlledInput.prototype, "onBlur", null);
    return ControlledInput;
}(React.Component));
exports.default = ControlledInput;
//# sourceMappingURL=controlled_input.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/components/controlled_input.js
// module id = dT/G
// module chunks = 20 21 22